import { ECategory } from 'shared/repositories/offers-comparison/entities/offer/OfferDesktopSchema';

export function isOfferCategory(category: string | null): category is ECategory {
  return Object.values(ECategory).includes(category as ECategory);
}
